import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import * as controller from '../user/controller'
import { withLocalize } from "react-localize-redux";
import * as Moment from 'moment'

class Users extends React.Component<any, any> {
  searchString: any

  constructor(props: any) {
    super(props);
    this.state = {
      users: [],
      usersFiltered: []
    }
  }

  search() {
      let usersFiltered = this.state.usersFiltered
      usersFiltered = this.state.users.filter((user: any) => {
        return user.name.includes(this.searchString.value.trim())
      })
      this.setState({usersFiltered})
  }

  loadUsers() {

  }

  componentDidMount() {


    fetch('users/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let users = data.users
        this.setState({users, usersFiltered: users}, () => {




          let terms = this.props.location.search.substring(1).split("&")
          terms.map((term:any) => {
            let name = term.split("=")[0]
            let value = term.split("=")[1]
            if(name == "category") {
              let usersFiltered = this.state.usersFiltered
              usersFiltered = this.state.users.filter((user: any) => {
                let found = false
                user.categories.map((category: any) => {
                  if(category.id == value) found = true
                })
                return found
              })
              this.setState({usersFiltered})
            }
          })




        })
    }).catch(err => {
      //alert(err.message);
    })



  }

  componentWillMount() {
    //Only users can see this page
    if(window.account.type != "admin")
      this.props.history.push("/login/admin")



  }


  public render() {
    const columns = [{
      Header: '#',
      accessor: 'id',
      maxWidth: 80,
      resizable: false
    }, {
      id: "categories",
      Header: this.props.translate("categories").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
           {row.value.categories.map((category:any, i:number) => (<span key={i}>{category.title}{i < row.value.categories.length-1? "," : ""}</span>))}
          </span>
        )
      },
    }, {
      Header: this.props.translate("name").toString(),
      accessor: 'name'
    }, {
      id: "engPer",
      Header: "אחוז מעורבות",
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
           {(row.value.instagramFollowers && row.value.avgLikes && row.value.avgComments)? ((parseInt(row.value.avgLikes) + parseInt(row.value.avgComments))/parseInt(row.value.instagramFollowers)*100).toFixed(2) : 0}%
          </span>
        )
      }
    }, {
      Header: this.props.translate("instagramFollowers").toString(),
      id: 'instagramFollowers',
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
            {row.value.instagramFollowers && row.value.instagramFollowers.toLocaleString('us-EN')}
          </span>
        )
      }
    }, {
      id: 'facebookFollowers',
      Header: this.props.translate("facebookFollowers").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
            {row.value.facebookFollowers && row.value.facebookFollowers.toLocaleString('us-EN')}
          </span>
        )
      }
    }, {
      Header: this.props.translate("youtubeFollowers").toString(),
      id: 'youtubeFollowers',
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
            {row.value.youtubeFollowers && row.value.youtubeFollowers.toLocaleString('us-EN')}
          </span>
        )
      }
    }, {
      id: "age",
      Header: this.props.translate("age").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return <span>{row.value.birthDate? Moment().diff(Moment(row.value.birthDate), 'years') : ""}</span>
      }
    }, {
      Header: this.props.translate("city").toString(),
      accessor: 'city'
    }, {
      Header: this.props.translate("phone").toString(),
      accessor: 'phone'
    }, {
      id: "sex",
      Header: this.props.translate("sex").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return row.value.sex == "male"? <span>זכר</span> : row.value.sex=="female"? <span>נקבה</span> : <span></span>
      }
    }, {
      id: "social",
      Header: this.props.translate("social").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <a href={row.value.facebook} target="_blank"><i className="fab socialIcon fa-facebook"></i></a>
        <a href={"https://www.instagram.com/"+row.value.instagram} target="_blank"><i className="fab socialIcon fa-instagram"></i></a>
        <a href={row.value.youtube} target="_blank"><i className="fab socialIcon fa-youtube"></i></a>
      </div>
    }, {
      id: 'settings',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      maxWidth: 100,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/users/" + row.value.id}><i className="fas fa-edit"></i></Link>
        <i onClick={controller.removeUser.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>
      </div>
    }]

    return (
      <div id="users-root">
        <input className="search" type="text" placeholder={this.props.translate("user.searchByName").toString()} onChange={this.search.bind(this)} ref={(searchString:any) => this.searchString = searchString} />

        <div className="board">
          <ReactTable
            data={this.state.usersFiltered}
            columns={columns}
            defaultPageSize={10}
            noDataText={this.props.translate("noResults").toString()}
            nextText={this.props.translate("next").toString()}
            previousText={this.props.translate("previous").toString()}
            rowsText={this.props.translate("rows").toString()}
            pageText={this.props.translate("page").toString()}
            ofText={this.props.translate("of").toString()}
            style={{
              height: "400px",
              textAlign: "center",
              fontSize: "1em",
              position: "centner",
              right: "0",
              left: "0",
              margin: "0 auto"
            }}
            className="-striped -highlight reactTable"
          />
        </div>
      </div>
    )
  }

}

export default withLocalize(Users)



// WEBPACK FOOTER //
// ./src/pages/users/Users.tsx